import {observer} from 'mobx-react';
import {lazy} from 'react';

const VerifyEmailPage = lazy(() =>
  import('./verify-email-page').then((module) => ({
    default: module.VerifyEmailPage,
  })),
);

export const installVerifyEmail = () => {
  const Page = observer(() => <VerifyEmailPage />);

  return {
    Page,
  };
};
